import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactTable from 'react-table';
import { getBasicSkillLevelId, getColumnWidth, getDollarPrice } from '../../../../helpers/general';
import { labels } from '../../../../constants/text';
import Loader from '../../../common/ui/Loader';
import AddCustomRateModal from '../AddCustomRateModal';
import Delete from '../../../common/forms/buttons/Delete';

export default class Rates extends Component {
  state = {
    isLoading: true,
    modalAddRateIsOpen: false
  };

  columnRenderer = data => {
    return [
      {
        Header: 'Job Skill',
        accessor: 'skill_label',
        width: getColumnWidth(data, 'skill_label', 'Job Skill')
      },
      {
        Header: 'Skill Level',
        accessor: 'skill_level_label',
        width: getColumnWidth(data, 'skill_level_label', 'Skill Level')
      },
      {
        Header: labels.pay_rate,
        accessor: 'pay_rate',
        Cell: props => {
          const { pay_rate } = props.original;
          return (
            <div>{getDollarPrice(pay_rate)}</div>
          );
        },
        width: getColumnWidth(data, 'pay_rate', labels.pay_rate)
      },
      {
        Header: labels.cost_rate,
        accessor: 'cost_rate',
        Cell: props => {
          const { cost_rate } = props.original;
          return (
            <div>{getDollarPrice(cost_rate)}</div>
          );
        },
        width: getColumnWidth(data, 'cost_rate', labels.cost_rate)
      },
      {
        Header: 'State',
        accessor: 'state',
        width: getColumnWidth(data, 'state', 'State')
      },
      {
        Header: 'City',
        accessor: 'city',
        width: getColumnWidth(data, 'city', 'City')
      },
      {
        Header: 'Zip',
        accessor: 'zip',
        width: getColumnWidth(data, 'zip', 'Zip')
      },
      {
        Header: 'Delete',
        accessor: 'delete',
        Cell: props => (
          <Delete onClick={() => this.removeCustomRate(props.original.id)} />
        ),
        width: 80
      }
    ];
  };

  toggleRateModal = () =>
    this.setState(prevState => ({
      modalAddRateIsOpen: !prevState.modalAddRateIsOpen
    }));

  removeCustomRate = id =>
    this.props.UIShowConfirm('Delete this custom rate?', () => this.props.deleteCustomRateAction(id));

  _setDataLoaded = () => this.setState({ isLoading: false });

  componentDidMount () {
    if (this.props.company) {
      const { company: { use_custom_rate }, getAllSkills, getSkillLevels, getCompanyDetailsAction, match: { params: { id } } } = this.props;
      if (use_custom_rate) {
        return Promise.all([
          getCompanyDetailsAction(id),
          getAllSkills(),
          getSkillLevels()
        ]).then(this._setDataLoaded);
      }
    }

    this._setDataLoaded();
  }

  render () {
    if (this.state.isLoading) {
      return <Loader />;
    }

    if (!this.props.company) {
      return null;
    }

    const { company: { id, custom_rates, use_custom_rate }, getCompanyDetailsAction, addCustomRateAction, skillsList,
      skillLevels, getGoogleAddressDetails } = this.props;

    if (!use_custom_rate) {
      return (
        <div className='alert alert-danger alert-static mt-3'>Custom rates usage disabled for this company</div>
      );
    }

    const { modalAddRateIsOpen } = this.state;
    const noRatesFound = !custom_rates || !custom_rates.length;

    return (
      <div>
        <button className='button button-primary' onClick={this.toggleRateModal}>
          Add Custom Rate
        </button>
        <div className='mb-4'>
          {noRatesFound ? (
            <div className='alert alert-info alert-static mt-3'>No custom rates found. Feel free to create one.</div>
          ) : (
            <div className='table-list-wrapper'>
              <ReactTable
                data={custom_rates}
                columns={this.columnRenderer(custom_rates)}
                minRows={custom_rates.length}
                showPageSizeOptions={false}
                showPagination={false}
              />
            </div>
          )}
        </div>
        <AddCustomRateModal
          isOpen={modalAddRateIsOpen}
          toggleModal={this.toggleRateModal}
          addCustomRateAction={addCustomRateAction}
          getCompanyDetailsAction={getCompanyDetailsAction}
          skillsList={skillsList}
          skillLevel={getBasicSkillLevelId(skillLevels)}
          company_id={id}
          getGoogleAddressDetails={getGoogleAddressDetails}
        />
      </div>
    );
  }
}

Rates.propTypes = {
  company: PropTypes.object,
  getGoogleAddressDetails: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/components/app/companyDetails/Tabs/Rates.js